import { Flex } from '@chakra-ui/react';
type subheadertype = {
  label: string;
};
/**
 * @useFor section labels INSIDE a drawer or detail panel — short
 *   uppercase title with a tinted background bar that groups
 *   related fields/rows within a single drawer body.
 *
 *   Examples in-tree: edit-drawer sections like CONTACT INFO /
 *   ROLES / SCHOOLS within the People edit drawer.
 *
 *   For top-of-page section headers with action buttons use
 *   `<SectionCard>` (it owns the header slot). For 2nd-tier page
 *   tabs use `<Tabs>`. SubHeader is specifically the "small
 *   uppercase label" pattern inside a panel.
 */
export const SubHeader = (props: subheadertype) => {
  const { label } = props;

  return (
    <Flex
      as="h3"
      bg={'surface.secondary'}
      color={'text.secondary'}
      textTransform={'uppercase'}
      fontSize={'12'}
      height={'28px'}
      alignItems={'center'}
      pl={'16px'}
      margin={0}
      data-e2e={`${label}-subheader`}
    >
      {label}
    </Flex>
  );
};
